import * as React from 'react';
import {DemographicsCache} from '../context/DemographicsCache';
import {PropsWithChildren, useState} from 'react';
import DataService from '../../shared/services/DataService';
import {useDemographicsStore} from '../hooks/useDemographicsStore';
import {DemographicData} from '../types/DemographicData';

export interface DemographicsStoreProps {
  clientId: string | undefined;
}

export const DemographicsStore = (props: PropsWithChildren<DemographicsStoreProps>) => {
  const [isProcessing, setIsProcessing] = useState<boolean>();

  const {
    getDemographics,
    getDemographicCategories,
    getDemographicAttributes,
    findDemographicByCode,
    findCategoryByCode,
    findAttributeByCode,
    findAttributesCategoryId,
    clearCache,
  } = useDemographicsStore(
    async (languageCode) => {
      setIsProcessing(true);
      try {
      return await DataService.tryLoad<DemographicData>(
        '/master-data/get-demographics',
        {
          clientId: props.clientId,
          languageCode: languageCode
        }
      );
      } finally {
        setIsProcessing(false);
      }
    },
    [props.clientId]
  );
  return (
    <DemographicsCache.Provider
      value={{
        getDemographics,
        getDemographicCategories,
        getDemographicAttributes,
        findDemographicByCode,
        findCategoryByCode,
        findAttributeByCode,
        findAttributesCategoryId,
        clearCache,
        isDemographicCacheProcessing: isProcessing
      }}
    >
      {props.children}
    </DemographicsCache.Provider>
  );
};
